import React from 'react'
import { createRoot } from 'react-dom/client'
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook'
import App from './App'
import AppProviders from './context/AppProviders'
import { GOOGLE_TAG_MANAGER_CUSTOM_DOMAIN, GOOGLE_TAG_MANAGER_ID } from './constants'

const gtmParams = {
	id: GOOGLE_TAG_MANAGER_ID,
	customDomain: GOOGLE_TAG_MANAGER_CUSTOM_DOMAIN,
}

const root = createRoot(document.getElementById('root'))

if (root) {
	root.render(
		<GTMProvider state={gtmParams}>
			<AppProviders>
				<App />
			</AppProviders>
		</GTMProvider>,
	)
}
